import { render, staticRenderFns } from "./LotteryResult.vue?vue&type=template&id=39f342a0&scoped=true&lang=pug&"
import script from "./LotteryResult.vue?vue&type=script&lang=js&"
export * from "./LotteryResult.vue?vue&type=script&lang=js&"
import style0 from "./LotteryResult.vue?vue&type=style&index=0&id=39f342a0&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39f342a0",
  null
  
)

export default component.exports